const purchaseDescription = document.querySelector('[data-component="purchase-description"]')

if (purchaseDescription) {
	const readMoreBtn = purchaseDescription.querySelector('[data-component="read-more"]')
	readMoreBtn.addEventListener('click', (e) => {
		purchaseDescription.classList.toggle('expanded')
	})
}